import React from 'react';

import {
	Box,
	ComposedElement,
	Typography,
	TypographyStyles,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { Check } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { rem } from '@helpers';

interface StepperProps {
	parentIndex: number;
	text: string;
	wasFinished: boolean;
	isCurrentMenu: boolean;
}

/**
 * Stepper
 *
 * @todo If Accolade change disabled color of Typography change palette.global.ui8 to palette.global.ui9
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export const Stepper: React.FC<StepperProps> = ({ parentIndex, text, wasFinished, isCurrentMenu }) => {
	const { colorPalette } = useTheme();

	return (
		<Box styles={{ alignItems: 'center' }}>
			{wasFinished ? (
				<ComposedElement
					icon={{ source: Check, svgProps: { fill: colorPalette.color_02[100] } }}
					container={{
						styles: {
							backgroundColor: colorPalette.color_01[50],
							color: colorPalette.color_01[50],
							border: `1px solid ${colorPalette.color_02[100]}`,
						},
					}}
				/>
			) : (
				<ComposedElement
					text={{
						content: (parentIndex + 1).toString(),
						props: {
							alternativeStyleProperties: {
								color:
									!isCurrentMenu && !wasFinished
										? colorPalette.color_01[100]
										: colorPalette.color_01[50],
							},
						},
					}}
					container={{
						styles: {
							backgroundColor:
								!isCurrentMenu && !wasFinished ? colorPalette.color_01[50] : colorPalette.color_02[100],
							color:
								!isCurrentMenu && !wasFinished
									? colorPalette.color_01[100]
									: colorPalette.color_02[100],
							border:
								!isCurrentMenu && !wasFinished ? `1px solid ${colorPalette.color_01[100]}` : undefined,
						},
					}}
				/>
			)}
			<Typography
				appearance={isCurrentMenu ? 'body-100-04' : 'body-100-02'}
				colorsLevel={!isCurrentMenu && !wasFinished ? 'disabled' : undefined}
				styles={{ marginLeft: rem(16), wordBreak: 'break-all' } as TypographyStyles}
			>
				{text}
			</Typography>
		</Box>
	);
};
